import React from "react";
import { PropertiesPage } from "properties/listing/PropertiesPage";
import { PropertiesPageContext } from "properties/listing/PropertiesPageContext";
import { propertiesRentingStore } from "properties/_stores/propertiesRentingStore";
import { PageRendererContext } from "properties/PropertiesPageContext";

export function RentPage() {
    return (
        <PropertiesPageContext store={propertiesRentingStore}>
            <PageRendererContext>
                <PropertiesPage />
            </PageRendererContext>
        </PropertiesPageContext>
    );
}
